import { render, staticRenderFns } from "./Knowhow.vue?vue&type=template&id=22560c60&scoped=true"
import script from "./Knowhow.vue?vue&type=script&lang=ts"
export * from "./Knowhow.vue?vue&type=script&lang=ts"
import style0 from "./Knowhow.vue?vue&type=style&index=0&id=22560c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22560c60",
  null
  
)

export default component.exports